export default "__VITE_ASSET__na6Bt0rx__"